
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpHeaders } from '@angular/common/http';
import { Ward } from '../../../interfaces/masters/ward';
import { WardBasedDefaultService } from '../../../interfaces/masters/Ward-Based-Default-Service';

@Injectable()
export class WardBasedDefaultServiceApi {

  constructor(private api: HttpService) { }

  list(url: string, options?: any): Observable<any> {
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }

  getById(url : string, options?: any): Observable<WardBasedDefaultService> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directGet(url,header);
  }

  add(url:string, data: WardBasedDefaultService):Observable<WardBasedDefaultService[]>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.post( url, data, header); 
  }

  delete(url: string):Observable<any>{
    return this.api.directDelete(url);
  }
}
